/**
 * Price range of a transfer / private driver / excursion listing for its SEO
 * texts and JSON-LD — the prices the page itself shows, never the stored
 * `price` field alone (an airport transfer has one price per zone, a private
 * driver one per duration, an excursion one adult price per pickup zone).
 * Same rule as the server (backend/services/listing_seo.py → offer()).
 */
const positive = (v) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const listingOffer = (service) => {
  const details = (service && service.details) || {};
  let prices = [];
  if (service?.category === 'excursion') {
    const pricing = (details.excursion || {}).pricing || {};
    const rows = pricing.price_by_zone ? (pricing.zone_prices || []) : [pricing];
    prices = rows.map((r) => positive(r && r.adult_price));
  } else if (service?.category === 'transfer') {
    ((details.transport || {}).airport_transfers || []).forEach((z) => {
      if (z) prices.push(positive(z.price), positive(z.price_from_airport), positive(z.price_to_airport));
    });
    // Phuket ↔ Krabi prices (one per route tier, backend/services/transfer_booking.py).
    Object.values(((details.transport || {}).route_prices || {})).forEach((tiers) => {
      Object.values(tiers || {}).forEach((p) => prices.push(positive(p)));
    });
  } else if (service?.category === 'private_driver') {
    prices = ((details.transport || {}).durations || [])
      .filter((d) => d && d.duration_hours).map((d) => positive(d.price));
  }
  prices = prices.filter((p) => p != null);
  if (!prices.length && positive(service?.price)) prices = [positive(service.price)];
  if (!prices.length) return null;
  return { low: Math.min(...prices), high: Math.max(...prices) };
};

/** schema.org Offer (one price) or AggregateOffer (a price range). */
export const offerJsonLd = (offer, url, sellerName) => {
  if (!offer) return undefined;
  const seller = sellerName ? { seller: { '@type': 'Organization', name: sellerName } } : {};
  if (offer.high > offer.low) {
    return { '@type': 'AggregateOffer', lowPrice: String(offer.low), highPrice: String(offer.high), priceCurrency: 'THB', url, ...seller };
  }
  return { '@type': 'Offer', price: String(offer.low), priceCurrency: 'THB', url, ...seller };
};
